<div class="create_popup">
    <div class="modal-body">
        <form [formGroup]="createForm" class="mb-3">

            <div class="product-row">
                <div class="row">
                    <h3>General Info</h3>

                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Order Id<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="employeeCode" /></span>
                        </div>
                    </div> -->

                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Job Code<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="jobCode" /></span>
                        </div>
                    </div> -->
                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Customer Name<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control" formControlName="accountId"
                                    readonly /></span>
                        </div>
                    </div> -->
                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Customer<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select [multiple]="false" formControlName="customerWarehouseId" appendTo="body" [ngClass]="editTrue ? 'disabled':''"
                                placeholder="" (ngModelChange)="onSelectWarehouseId($event)">
                                <ng-option *ngFor="let item of customerDetails?.accountLocationMappings"
                                    [value]="item">{{item?.warehouseCode}}</ng-option>
                            </ng-select>

                        </div>
                    </div> -->

                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Tonnage: </b>
                        </div>
                        <div class="col-md-12">
                            <input type="text" trim="blur" class="form-control" formControlName="tonnage" />
                        </div>
                    </div>


                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Date/Time of Placement<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <p-calendar class="dateRange" formControlName="placementDate" [minDate]="minDate"
                                dateFormat="dd/mm/yy" [showTime]="true" [showIcon]="true" placeholder=""></p-calendar>

                        </div>
                    </div>


                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Status<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="employeeName" /></span>
                        </div>
                    </div> -->




                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Vehicle Type<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select [multiple]="false" formControlName="customerWarehouseId" appendTo="body" [ngClass]="editTrue ? 'disabled':''"
                                placeholder="" (ngModelChange)="onSelectWarehouseId($event)">
                                <ng-option *ngFor="let item of customerDetails?.accountLocationMappings"
                                    [value]="item">{{item?.warehouseCode}}</ng-option>
                            </ng-select>

                        </div>
                    </div> -->
                    <div class="col-sm-3 mb-3">
                        <div class="col-md-12">
                            <b>Material Type<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    (keypress)="sharedService.isNumberOnly($event)"
                                    formControlName="materialType" /></span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Remarks: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="remarks" /></span>
                        </div>
                    </div>
                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Vendor: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select appendTo="body" formControlName="vendorId" [items]="vendorInfo" bindValue="id" bindLabel="vendorName" [multiple]="true">

                            </ng-select>
                        </div>
                    </div> -->
                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                    <div class="col-md-12">
                        <b>Warehouse<span style="color:red">*</span>: </b>
                    </div>
                    <div class="col-md-12">

                        <ng-select [multiple]="true"
                        formControlName="userWarehouseMapping" appendTo="body" placeholder="">
                        <ng-option *ngFor="let item of wareHouseList" [value]="item">{{item?.accountName}} - {{item?.warehouseName}}</ng-option>
                       </ng-select>
                    </div>
                </div> -->




                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                    <div class="col-md-12">
                        <b>Whatsapp Notification:</b>
                    </div>
                    <div class="col-md-12">
                        <input type="checkbox" [checked]="whatsappStatus">
                    </div>
                </div> -->

                </div>

            </div>

            <div class="product-row">
                <div class="row">
                    <h3>Contact Person Details</h3>

                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Name<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="contactName" /></span>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Mobile<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control" formControlName="contactMobile"
                                    (keypress)="sharedService.isNumberKey($event)" maxlength="10" /></span>
                        </div>
                    </div>


                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Alternate Mobile: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="contactAlternateMobile"
                                    (keypress)="sharedService.isNumberKey($event)" maxlength="10" /></span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Email<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="email" trim="blur" class="form-control"
                                    formControlName="contactEmail" /></span>
                        </div>
                    </div>

                    <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Address<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="employeeName" /></span>
                        </div>
                    </div> -->

                </div>

            </div>



        </form>

        <div class="product-row">
            <div class="row">
                <h3>Route Details</h3>

                <form [formGroup]="routeForm">
                    <div class="form-row">
                        <div class="row w-100">
                            <div class="col-sm-3 mb-3">
                                <div class="col-md-12">
                                    <b>Route<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <ng-select [multiple]="false" formControlName="routeId" appendTo="body"
                                        placeholder="">
                                        <ng-option *ngFor="let vehicle of vehicleTypeList" [value]="vehicle?.id">{{
                                            vehicle?.vehicleType}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-3 mb-3">
                                <div class="col-md-12">
                                    <b>Vehicle Type<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <ng-select [multiple]="false" formControlName="vehicleProvide" appendTo="body"
                                        placeholder="">
                                        <ng-option *ngFor="let vehicle of vehicleTypeList" [value]="vehicle?.id">{{
                                            vehicle?.vehicleType}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-3 mb-3">
                                <div class="col-md-12">
                                    <b>No. of Vehicle<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <span><input type="text" trim="blur" class="form-control"
                                            formControlName="numberOfVehicle"
                                            (keypress)="sharedService.isNumberOnly($event)" /></span>
                                </div>
                            </div>
                            <div class="col-sm-3 mb-3">
                                <div class="col-md-12">
                                    <b>Price<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <span><input type="text" trim="blur" class="form-control"
                                            (keypress)="sharedService.isNumberOnly($event)"
                                            formControlName="maxSalary" /></span>
                                </div>
                            </div>





                        </div>
                    </div>
                    <div class="form-row">
                        <div class="row w-100">
                            <div class="col-sm-4 mb-3">
                                <div class="col-md-12">
                                    <b>Source Address<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <input type="text" trim="blur" class="form-control" formControlName="sourceAddress" />
                                </div>
                            </div>

                            <div class="col-sm-4 mb-3">
                                <div class="col-md-12">
                                    <b>Destination Address<span style="color:red">*</span>: </b>
                                </div>
                                <div class="col-md-12">
                                    <input type="text" trim="blur" class="form-control" formControlName="destinationAddress" />
                                </div>
                            </div>
                            <div class="col-sm-3 mb-3">
                                <div class="col-md-12">
                                    <b>&nbsp;</b>
                                </div>
                                <a class="btn btn-primary">+ Add Address</a>
                            </div>
                        </div>
                    </div>
                    <!-- <input formControlName="headCount" placeholder="Head Count Needed *" type="number" /> -->
                    <!-- <input formControlName="dateRange" placeholder="From - to *" type="text" />
      <input formControlName="experience" placeholder="Min Experience (Years) *" type="number" />
      <select formControlName="type">
        <option *ngFor="let type of manpowerTypes" [value]="type">{{ type }}</option>
      </select>
      <input formControlName="maxSalary" placeholder="Max Salary *" type="number" /> -->


                    <button type="button" (click)="onSubmit()" class="btn btn-primary">
                        {{ editIndex !== null ? 'Update' : '+ Add Route ' }}
                    </button>
                </form>
            </div>

            <!-- Table View -->
            <table class="table" *ngIf="manpowerList.length > 0">
                <thead>
                    <tr>
                        <th>Route</th>
                        <!-- <th>Date Range</th> -->
                        <th>Vehicle Type</th>
                        <th>No. of Vehicle</th>
                        <th>Price</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of manpowerList; let i = index">
                        <td>{{ item.routeId }}</td>
                        <!-- <td>
                            {{ item.dateRange }}
                             {{
                                item.dateRange?.[0] | date: 'dd-MM-yyyy'
                            }} -
                            {{
                                item.dateRange?.[1] | date: 'dd-MM-yyyy'
                            }}
                        </td> -->
                        <td>{{ item.vehicleProvide }}</td>
                        <td>{{ item.numberOfVehicle }}</td>
                        <!-- <td>{{ getSkillNameById(item.skillId) }}</td> -->
                        <td>{{ item.maxSalary }}</td>
                        <td>
                            <button (click)="editRow(i)" class="btn btn-primary me-2"><i
                                    class="bi bi-pencil-square"></i></button>
                            <button (click)="removeRow(i)" class="btn btn-primary btn-danger"><i
                                    class="bi bi-trash3"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-container *ngIf="!isOrderSubmitSuccessfully">
            <button class="btn btn-primary mr-3" [disabled]="!createForm.valid"
                (click)="submitForm('submit')">Submit</button>
        </ng-container>
        <ng-container *ngIf="isOrderSubmitSuccessfully || this.EditData?.status == 'Created'">
            <button class="btn btn-primary mr-3" (click)="pushToVendor()">Push to
                Vendor</button>
        </ng-container>
        <ng-container *ngIf="!isOrderSubmitSuccessfully ">
            <button *ngIf=" this.EditData?.status !== 'Created'" class="btn reset-btn btn-cancel mr-3"
                [disabled]="!createForm.valid" (click)="submitForm('draft')">Save as Draft</button>
        </ng-container>
    </div>